module.exports = __webpack_public_path__ + "img/7_60.09980e9e.png";